import React from 'react';

export default function BudgetApproval() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Budget Approval</h1>
      <p className="text-gray-500">Halaman Budget Approval</p>
    </div>
  );
}
